export function isRestrictedEmailDomain(email: string, restrictedEmailDomains: string[]): boolean {
  if (!email) {
    return false;
  }
  return restrictedEmailDomains.some((domain: string) => email.split('@')[1] === domain);
}
